module.exports = __webpack_public_path__ + "static/img/037开江鱼美食节1.03f9834.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/037开江鱼美食节1.jpg
// module id = tWmL
// module chunks = 0